<template>
    <div id="record_receipt" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="ReceiptHeader">Record Receipt</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackReceiptList">
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content record-receipt">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="RecordReceiptForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group mt-4" v-if="poNum != ''">
                                        <label class="control-label" for="po_num">PO: &nbsp;&nbsp;{{poNum}}</label>
                                    </div>
                                    <div class="col form-group mt-4">
                                        <label class="control-label" for="receipt_number">Receipt Number: &nbsp;&nbsp;{{receipt_number}}</label>
                                    </div>
                                    <div class="col form-group mt-4">
                                        <label class="control-label" for="locatoin">Location: &nbsp;&nbsp;{{location}}</label>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="received_by">Received By:</label>
                                        <v-select v-model="received_by" name="received_by" id="received_by"
                                            label="text" :filterable="false" :options="userArr"
                                            @search="onSearchSalesRepresentative"
                                            placeholder="Select Received By" class="custom-ci-auto-search contract-data">
                                            <template slot="no-options">
                                                Search Received By...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ salesrepresentativeerrormsg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="receipt_date">Receipt Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="receipt_date" name="receipt_date" v-model="receipt_date" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="receipt_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{receipt_date_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="purchase-order-create-main table-responsive">
                                    <table aria-describedby="table" class="table table-sm table-bordered">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" v-if="poType == 'misc'" style="width:300px">Description</th>
                                                <th scope="col" v-else style="width:300px">Item</th>
                                                <th scope="col" class="require">Warehouse</th>
                                                <th scope="col">RSB</th>
                                                <th scope="col">UOM</th>
                                                <th scope="col">Ordered</th>
                                                <th scope="col">Open Qty</th>
                                                <th scope="col" class="require">Received Qty</th>
                                                <th scope="col" class="require">Cost</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="rows.length > 0">
                                            <tr v-for="(row, index) in rows" :key="index">
                                                <td v-if="poType == 'misc'">
                                                    <input type="text" :disabled="true" placeholder="Enter Description" v-model="row.description" name="description" id="description" class="form-control">
                                                </td>
                                                <td v-else>
                                                    <v-select :disabled="true" v-model="row.part" name="part" id="part" label="text" :filterable="false" :options="componentArr" @search="onSearchComponent" placeholder="Select Part" class="custom-ci-auto-search contract-data">
                                                        <template slot="no-options">
                                                            Search Part...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                </td>
                                                <td>
                                                    <v-select v-model="row.warehouse_id" name="warehouse_id" id="warehouse_id" label="text" :filterable="true" :options="row.warehouseArr" @input="load_rsb_ddl(index)" placeholder="Select Warehouse" class="custom-ci-auto-search contract-data warehouse-select">
                                                    </v-select>
                                                    <div class="field-error">{{row.warehouse_id_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <v-select v-model="row.rsb" name="rsb" id="rsb" label="text" :filterable="true" :options="row.rsbArr" placeholder="Select RSB" class="custom-ci-auto-search contract-data rsb-select">
                                                    </v-select>
                                                </td>
                                                <td>
                                                    <input type="text" :disabled="true" placeholder="Enter Type" v-model="row.uom" name="type" id="type" class="form-control">
                                                </td>
                                                <td>
                                                    <input type="text" :disabled="true" placeholder="Ordered Qty" v-model="row.quantity" name="quantity" id="quantity" @keypress="isNumberKey($event)" class="form-control">
                                                </td>
                                                <td>
                                                    <input type="text" :disabled="true" placeholder="Open Qty" v-model="row.open_quantity" name="open_quantity" id="open_quantity" class="form-control text-right" @keypress="isNumberKey($event)">
                                                </td>
                                                <td>
                                                    <input type="text" placeholder="Received Qty" v-model="row.received_qty" name="received_qty" id="received_qty" class="form-control text-right rcvd-qty" @keypress="isNumberOnly($event)">
                                                    <div class="field-error">{{row.received_qty_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text" placeholder="Cost" v-model="row.cost" name="cost" id="cost" class="form-control text-right rcvd-cost" @keypress="isAmountCheck($event)">
                                                    <div class="field-error">{{row.cost_error_msg}}</div>
                                                </td>
                                            </tr>
                                            </template>
                                            <template v-else>
                                                <tr>
                                                    <td colspan="6" class="text-center">
                                                        No Item Found
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="field-error">{{common_error_msg}}</div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createReceiptBtn" v-if="$route.params.id != undefined" class="btn btn-primary" v-on:click.prevent="CreateReceipt('')">
                                    <i class="fp-save"> </i>  Update
                                    </button>
                                    <button type="submit" id="createReceiptBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateReceipt('')">
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" v-if="$route.params.id == undefined" id="createAndCreateInvoiceOrderBtn" class="btn btn-tertiary" v-on:click.prevent="CreateReceipt(flag='Invoice')">
                                      <i class="fp-save-continue"> </i> Save and Create Invoice
                                    </button>
                                    <button type="submit" id="cancelReceiptBtn" class="btn btn-secondary" v-on:click.prevent="BackReceiptList">
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<style scoped>
.table-responsive {
    overflow-x: visible;
}
.warehouse-select {
 min-width:200px;
}
.rsb-select {
 min-width:150px;
}
</style>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import moment from 'moment'


export default {
  name: "ReceiptCreate",

  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Receipt | " +process.env.COPYRIGHT_NAME : "Create Receipt | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    loading:false,
    receipt_number:'',
    rows:[],
    receipt_date:'',
    receipt_date_error_msg:'',
    optionsDate: {
        format: 'MM/DD/YYYY hh:mm:ss A',
        useCurrent: false,
        toolbarPlacement:'bottom',
        widgetPositioning: {
            horizontal: 'auto',
            vertical: 'bottom'
        },
        showClose: true,
    },
    componentArr:[],
    salesrepresentativeerrormsg:'',
    received_by:'',
    userArr:[],
    location:'',
    vendor_id:'',
    location_id:'',
    common_error_msg:"",
    redirectFrom:'',
    poid:'',
    type:'',
    poType:'',
    poNum:'',
    poListUrl:''
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'record_receipt') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();

        var path = window.location.pathname;
        var segments = path.split("/");

        if (segments[3]){
            self.loadReceiptItem(segments[3]);
        }else{
            setTimeout(function () {

                if (self.$route.query.po != undefined && self.$route.query.po > 0){
                    self.poid = self.$route.query.po;
                    self.loadPoItem(self.$route.query.po);
                }

                if (self.$route.query.data != '' && self.$route.query.data != undefined) {
                    var webloc = window.location.href;

                    var decodeStr = "";
                    decodeStr = atob(self.$route.query.data)

                    var url = new URL(webloc+"?"+decodeStr);
                    self.poid = url.searchParams.get("id");
                    self.type = url.searchParams.get("type");

                    self.redirectFrom = url.searchParams.get("redirectFrom");
                    self.poListUrl = url.searchParams.get("poList");

                    // self.vendor_inv_type = type;
                    // if (self.vendor_inv_type == "sublet_po") {
                    //     self.vendor_invoice_type = {text:'Sublet Invoice' , value:'sublet_invoice'};
                    // }
                    console.log("id :: " + self.poid);
                    console.log("type :: " + self.type);
                    self.loadPoItem(self.poid);
                    // self.loadPurchaseOrder(id);
                    // self.loadPurchaseOrderItem(id);
                }

                self.fetchReceiptNumber();

            }, 100);
            var userObj = JSON.parse(localStorage.getItem("user_obj"));
            if(userObj != null){
                var name = self.titleCase(userObj["first_name"]);
                if ( userObj["last_name"] != "" && userObj["last_name"] != null &&  userObj["last_name"] != undefined) {
                    name += " " +  self.titleCase(userObj["last_name"]);
                }
                self.received_by = {value: userObj["id"], text : name};
            }
        }

        //use up and bottom arrow to navigate
        $(document).keyup(function (e) {

            if ( $(e.target).hasClass( "rcvd-qty" )) {
                if ( e.keyCode == 40 ) {
                    $(e.target).parent().parent().next('tr').find('.rcvd-qty').focus();
                }
                if ( e.keyCode == 38 ) {
                    $(e.target).parent().parent().prev('tr').find('.rcvd-qty').focus();
                }
            }
            if ( $(e.target).hasClass( "rcvd-cost" )) {
                if ( e.keyCode == 40 ) {
                    $(e.target).parent().parent().next('tr').find('.rcvd-cost').focus();
                }
                if ( e.keyCode == 38 ) {
                    $(e.target).parent().parent().prev('tr').find('.rcvd-cost').focus();
                }
            }
        });


  },
  methods: {
    BackReceiptList() {
      var self = this;
      if(self.redirectFrom != undefined && self.redirectFrom != '' && self.redirectFrom == 'poview'){
          self.$router.push('/vendor-purchase-order/view/'+self.poid);
      }else{
        if (self.$route.params.id != undefined && self.$route.params.id > 0) {
            self.$router.push("/record-receipt/list");
        }else{
            self.$router.push("/order-history/list");
        }
      }
    },
    onSearchComponent(search, loading) {
        var self = this;
        if (search.length > 1) {
            loading(true);
            self.searchField(loading, search, 'component', '');
        }
    },
    onSearchSalesRepresentative(search, loading) {
        var self = this;
        if (search.length > 0) {

            loading(true);
            self.searchField(loading, search, 'user', '');
        }
    },
    loadPoItem:function(poId){
        var self = this;
        // var poId = self.$route.query.po;
        $.ajax({
            url: process.env.ROOT_API + "/fetch-po-item",
            type: "GET",
            headers: this.ajxHeaders,
            data:{
                po_id:poId
            },
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {

                    self.rows = [];
                    if (data.content.length >= 1) {
                        if (data.content[0].locCode){

                            self.location = data.content[0].locCode+' | '+data.content[0].locName;

                        }
                        if (data.content[0].location_id){

                            self.location_id = data.content[0].location_id;

                        }
                        if (data.content[0].vendor_id){

                            self.vendor_id = data.content[0].vendor_id;

                        }
                        if (data.content[0].po_no){

                            self.poNum = data.content[0].po_no;

                        }
                        self.poType = data.content[0].type;
                        var receivedQtyArr = [];
                        if (data.received_qty != undefined && data.received_qty != null) {
                            var receivedQtyArr = data.received_qty;
                        }
                        var warehouseListArr = [];
                        if (data.warehouse_list != undefined && data.warehouse_list != null) {
                            var warehouseListArr = data.warehouse_list;
                        }
                        for (var i = 0; i < data.content.length; i++) {
                            var itemId = null;
                            var warehouse_mapper_list = [];
                            var rsb_mapper_list = [];
                            var poItemId = data.content[i].id;
                            var receivedQty = 0;
                            if (poItemId != null) {
                                var itemObj = receivedQtyArr.find(item => item.po_item_id === poItemId);
                                if (itemObj != undefined && itemObj != null) {
                                    receivedQty = itemObj.received_qty;
                                }
                            }

                            if (itemObj != null) {
                                console.log(warehouseListArr);
                                for (var x = 0; x < warehouseListArr.length; x++) {
                                    warehouse_mapper_list.push({
                                        value: warehouseListArr[x].id,
                                        text: warehouseListArr[x].code + ' | ' + warehouseListArr[x].name
                                    });
                                }
                            }
                            if (itemObj != null) {
                                console.log(itemObj.rsb_list);
                                for (var x = 0; x < itemObj.rsb_list.length; x++) {
                                    rsb_mapper_list.push({
                                        value: itemObj.rsb_list[x].id,
                                        text: itemObj.rsb_list[x].row + ' | ' + itemObj.rsb_list[x].shelf + ' | ' + itemObj.rsb_list[x].bin
                                    });
                                }
                            }
                            if (data.content[i].item_id != null) {
                                itemId = {
                                    value: data.content[i].item_id,
                                    text: data.content[i].iCode + " | " + data.content[i].iName
                                };
                            }
                            if (itemObj != null) {
                                console.log(warehouseListArr);
                                for (var x = 0; x < warehouseListArr.length; x++) {
                                    warehouse_mapper_list.push({
                                        value: warehouseListArr[x].id,
                                        text: warehouseListArr[x].code + ' | ' + warehouseListArr[x].name
                                    });
                                }
                            }
                            if (itemObj != null) {
                                console.log(itemObj.rsb_list);
                                for (var x = 0; x < itemObj.rsb_list.length; x++) {
                                    rsb_mapper_list.push({
                                        value: itemObj.rsb_list[x].id,
                                        text: itemObj.rsb_list[x].row + ' | ' + itemObj.rsb_list[x].shelf + ' | ' + itemObj.rsb_list[x].bin
                                    });
                                }
                            }
                            var openQty = data.content[i].quantity;
                            var openQuantity = openQty - receivedQty;
                            //to remove line item from po with open quantity zero
                            if (typeof openQuantity != 'undefined' && openQuantity != 0) {

                                self.rows.push({
                                    purchase_order_item_id: data.content[i].id,
                                    quantity: data.content[i].quantity,
                                    open_quantity: openQuantity,
                                    unit_price: data.content[i].unit_price,
                                    unit_price_error_msg: "",
                                    description: data.content[i].description,
                                    amount: data.content[i].total,
                                    part: itemId,
                                    warehouseArr: warehouse_mapper_list,
                                    warehouse_id:data.content[i].warehouse_id,
                                    warehouse_id_error_msg:'',
                                    uom: (data.content[0].type == 'misc')?data.content[i].uomName:data.content[i].uom,
                                    warehouse_id:data.content[i].warehouse_id,
                                    warehouse_id_error_msg:'',
                                    received_qty:0,
                                    received_qty_error_msg:'',
                                    cost:data.content[i].unit_price,
                                    cost_error_msg:''
                                });

                            }
                        }
                    }else{
                        self.$swal('','Purchase order do not have item with component','info');
                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'fetch-po-items');
            }
        });
    },

    loadReceiptItem:function(id){
        var self = this;
        // var poId = self.$route.query.po;

        $.ajax({
            url: process.env.ROOT_API + "/record-receipt/"+id,
            type: "POST",
            headers: this.ajxHeaders,

            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {

                    self.rows = [];
                    var dataSet = data.content.data;
                    self.location = dataSet.location;
                    self.location_id = dataSet.location_id;
                    self.receipt_number = dataSet.receipt_number;
                    self.received_by = {text:dataSet.user,value:dataSet.received_by};
                    self.receipt_date = dataSet.receive_datetime;
                    if (dataSet.vendor_id){

                        self.vendor_id = dataSet.vendor_id;

                    }
                    self.poType = dataSet.type;
                    self.poid = dataSet.po_id;
                    self.poNum = dataSet.po_no;

                    if (data.content.item.length >= 1) {

                        for (var i = 0; i < data.content.item.length; i++) {
                            var itemId = null;
                            if (data.content.item[i].item_id != null) {
                                itemId = {
                                    value: data.content.item[i].item_id,
                                    text: data.content.item[i].item
                                };
                            }

                            self.rows.push({
                                receipt_item_id:data.content.item[i].id,
                                purchase_order_item_id: data.content.item[i].po_item_id,
                                quantity: data.content.item[i].po_quantity,
                                open_quantity: data.content.item[i].open_quantity,
                                unit_price: 0,
                                unit_price_error_msg: "",
                                amount: 0,
                                part: itemId,
                                warehouseArr: warehouse_mapper_list,
                                rsbArr: rsb_mapper_list,
                                description: data.content.item[i].description,
                                uom: data.content.item[i].uom,
                                warehouse_id:data.content[i].warehouse_id,
                                warehouse_id_error_msg:'',
                                received_qty:data.content.item[i].quantity,
                                received_qty_error_msg:'',
                                cost:data.content.item[i].cost,
                                cost_error_msg:''
                            })
                        }
                    }else{
                        self.$swal('','Purchase order do not have item with component','info');
                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'fetch-po-items');
            }
        });
    },

    fetchReceiptNumber: function(){

        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/po-receipt-number-fetch",
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            data:{poid:self.poid},
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                   self.receipt_number = data.content;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'fetch-receipt-number')
            }
        });
    },

    CreateReceipt(flag) {
      var self = this;

      self.salesrepresentativeerrormsg = "";
      self.receipt_date_error_msg = "";
      self.common_error_msg = "";
      var error = false;
      if (!self.receipt_date || self.receipt_date == null || self.receipt_date == "") {
        self.receipt_date_error_msg = "Receipt Date Required.";
        error = true;
      }
      if (!self.received_by || self.received_by == null || !self.received_by.value) {
        self.salesrepresentativeerrormsg = "Received By Required.";
        error = true;
      }
      if (!self.rows.length) {
          self.common_error_msg = "Purchase order do not have item with component";
          error = true;
      }

        for (var i = 0; i < self.rows.length; i++) {
                    // console.log(self.rows[i]);
            self.rows[i].warehouse_id_error_msg = "";
            self.rows[i].received_qty_error_msg = "";
            self.rows[i].cost_error_msg = "";
            self.rows[i].warehouse_id_error_msg = "";

            if (self.rows[i].warehouse_id == null || self.rows[i].warehouse_id == '' || self.rows[i].warehouse_id == 0) {
                self.rows[i].warehouse_id_error_msg = "Please Select Warehouse.";
                error = true;
            }
            if (self.rows[i].received_qty == null || self.rows[i].received_qty == '' || self.rows[i].received_qty == 0) {
                self.rows[i].received_qty_error_msg = "Received Quantity is Required.";
                error = true;
            }

            if (self.rows[i].warehouse_id == null || self.rows[i].warehouse_id == '' || self.rows[i].warehouse_id == 0) {
                self.rows[i].warehouse_id_error_msg = "Please Select Warehouse.";
                error = true;
            }

            let received_qty = self.rows[i].received_qty;
            let open_quantity = Number(self.rows[i].open_quantity);

            // Taking absolute values for comparison
            let abs_received_qty = Math.abs(received_qty);
            let abs_open_quantity = Math.abs(open_quantity);

            if (self.rows[i].received_qty != null && self.rows[i].received_qty != '' && abs_received_qty > abs_open_quantity) {
                self.rows[i].received_qty_error_msg = "Received Quantity Should not be greater than open quantity.";
                error = true;
            }
            if (!self.rows[i].cost || self.rows[i].cost  == null || self.rows[i].cost == "") {
                self.rows[i].cost_error_msg = "Cost is Required.";
                error = true;
            }
        }

      if (!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");

            $("#createReceiptBtn").val("Saving ...");
            $("#createReceiptBtn").prop("disabled", true);
            $("#createAndContinueReceiptBtn").prop("disabled", true);
            $("#cancelReceiptBtn").prop("disabled",true);

            var fields = $("#RecordReceiptForm").serializeArray();

            fields.push({
                    name: "receipt_number",
                    value: self.receipt_number
                });

            fields.push({
                    name: "items",
                    value: JSON.stringify(self.rows)
                });

            fields.push({
                name: "vendor_id",
                value: self.vendor_id
            });

            fields.push({
                name: "received_by",
                value: self.received_by.value
            });

            fields.push({
                name: "receipt_date",
                value: self.receipt_date
            });

            fields.push({
                name: "location_id",
                value: self.location_id
            });

            fields.push({
                name: "vendor_po_id",
                value: self.poid
            });

            if (segments[3]){
                fields.push({
                    name: "id",
                    value: segments[3]
                });
            }


            $.ajax({
                url: process.env.ROOT_API + "/po-receipt/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    $("#createReceiptBtn").val("Save");
                    $("#createReceiptBtn").prop("disabled", false);
                    $("#createAndContinueReceiptBtn").prop("disabled", false);
                    $("#cancelReceiptBtn").prop("disabled",false);

                    if (data.code == 201){
                        self.$swal('',data.message,'info');
                        return;
                    }
                    if (data.status == "success") {
                        if (flag == "Invoice") {
                            //take receipt and po reference to create vendor invoice
                            if (data.content.id != undefined && data.content.id != null) {
                                var url = '&id=' + self.poid +'&receipt_id=' + data.content.id + '&type=' + self.type+'&redirectFrom=receiptcreate&poList='+self.poListUrl;
                                self.$router.push({ name: 'BillCreate', query: { data : btoa(url) }});
                                return;
                            }
                        }

                        // if (flag == "Save and Continue") {

                        //     $("#RecordReceiptForm").trigger("reset");
                        //     self.bank_code = {text:'',value:''};
                        //     self.bank_currency_code = 'USD';
                        //     self.bank_currency_code = 'USD';
                        //     self.receipt_date = '';
                        //     self.deposit_date = '';
                        //     self.bank_reference = '';
                        //     self.receipt_amount = 0;
                        //     self.rows = [];

                        //     self.rows.push({
                        //         receipt_item_id: 0,
                        //         payment_number: '',
                        //         payment_number_error_msg: "",
                        //         type: "",
                        //         type_error_msg: "",
                        //         payment_date: null,
                        //         payment_date_error_msg: "",
                        //         amount: 0,
                        //         amount_error_msg:'',

                        //     });


                        // }else{
                            if (segments[3]){
                                self.$router.push("/record-receipt/list");
                            }else{
                                if(self.redirectFrom != undefined && self.redirectFrom != '' && self.redirectFrom == 'poview'){
                                    self.$router.push('/vendor-purchase-order/view/'+self.poid);
                                }else{
                                    if (self.$route.params.id != undefined && self.$route.params.id > 0) {
                                        self.$router.push("/record-receipt/list");
                                    }else{
                                        self.$router.push("/order-history/list");
                                    }
                                }
                            }
                        // }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;

                    $("#createReceiptBtn").val("Save");
                    $("#createReceiptBtn").prop("disabled", false);
                    $("#createAndContinueReceiptBtn").prop("disabled", false);
                    $("#cancelReceiptBtn").prop("disabled",false);

                    self.generateStatusCodeMessage(jqXHR,true,'reason-create')
                }
            });
      }else{
                self.errorValidationFocus();
      }

    },

    load_rsb_ddl(index) {
      var self = this;
      var warehouse_id = null;
      if (self.rows[index].warehouse_id) {
        warehouse_id = self.rows[index].warehouse_id.value
      }
      var item_id = self.rows[index].part.value;

      self.rows[index].rsbArr = [];
      self.rows[index].rsb = [];

      if (warehouse_id) {
        $.ajax({
          url: process.env.ROOT_API + "/rsb-dropdown-data",
          type: "POST",
          headers: {
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Authorization": "Bearer " + localStorage.getItem("tkn"),
            "Access-Control-Allow-Headers":
                "Origin, Content-Type, Authorization,X-Requested-With",
            "Cache-Control": "no-cache"
          },
          data: {
            warehouse_id: warehouse_id,
            item_id: item_id
          },
          dataType: "json",
          success: function (data) {
            self.loading = false;
            if (data.status == "success") {
              if (data.content.length >= 1) {
                var rsb_mapper_list = [];
                var new_rows = self.rows
                for (var i = 0; i < data.content.length; i++) {
                  rsb_mapper_list.push({
                    value: data.content[i].id,
                    text: data.content[i].row + ' | ' + data.content[i].shelf + ' | ' + data.content[i].bin
                  });
                }
                new_rows[index].rsbArr = rsb_mapper_list;
                self.rows = [...new_rows];
              } else {
                self.$swal('', 'No RSB found for this warehouse', 'info');
                self.rows[index].rsbArr = [];
                self.rows[index].rsb = [];
              }
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            self.generateStatusCodeMessage(jqXHR, false, 'fetch-po-items');
          }
        });
      }
    },

    isNumberKey: function(evt) {

        var self = this;

        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
            evt.preventDefault();
        } else {
            return true;
        }
    },
  }
};
</script>
<style scoped>
.table-responsive {
    overflow-x: visible;
}
.warehouse-select {
 min-width:200px;
}
.rsb-select {
 min-width:150px;
}
</style>



// WEBPACK FOOTER //
// src/components/RecordReceipt.vue